import React from 'react'
import { useVerificationFlow } from './VerificationFlowContext'
import VerificationFlowModal from './components/VerificationFlowModal'

/**
 * This component manages the verification flow UI
 * Uses a unified modal approach where a single modal container is used
 * with different content views based on the current state
 */
const VerificationFlowManager = () => {
  // Simply render the unified modal container
  // The container will handle which view to show based on the current state
  return <VerificationFlowModal />
}

export default VerificationFlowManager
